
define(
	'TavanoTeam.CSExtensions.CSCertCaptureExt'
	, [
		'TavanoTeam.CSExtensions.CSCertCapture.Router'
		, 'TavanoTeam.CSExtensions.CSCertCapture.Checkout.View'

		, 'SC.Configuration'

		, 'jQuery'
	]
	, function (
		CertCaptureRouter
		, CSCertCaptureCheckoutView

		, Configuration

		, jQuery
	) {
		'use strict';

		return {
			loadCertCapture: function loadCertCapture(container) {
				var myaccount_menu = container.getComponent('MyAccountMenu')
					, layout = myaccount_menu.application.getLayout()
					, self = this;

				layout.on('afterAppendView', function () {
					self.loadCertCaptureScript();
				});

				var certmenugroup = {
					id: "certlist"
					, name: "Tax Exempt Certs"
					, index: 5
					, permissionoperator: "OR"
					, permission: []
				};

				var curr_cert = {
					id: "currentcert"
					, groupid: "certlist"
					, name: "Certificates List"
					, index: 1
					, url: "certificates/list"
					, permissionoperator: "OR"
					, permission: []
				};

				var new_cert = {
					id: "newcert"
					, groupid: "certlist"
					, name: "Upload New Certificate"
					, index: 2
					, url: "certificates/new"
					, permissionoperator: "OR"
					, permission: []
				};

				myaccount_menu.addGroup(certmenugroup);
				myaccount_menu.addGroupEntry(curr_cert);
				myaccount_menu.addGroupEntry(new_cert);

				return new CertCaptureRouter(myaccount_menu);
			}

			, loadCertCaptureScript: function () {
				var script = document.createElement('script')
					, certCaptureScript = Configuration.get("certCapture.scriptURL");

				script.type = "text/javascript";
				script.src = certCaptureScript;

				jQuery("head").append(script);
			}

			, loadCertCaptureCheckout: function loadCertCaptureCheckout(container) {
				var checkout = container.getComponent('Checkout');

				if (checkout) {

					var index = Configuration.get("certCapture.moduleIndex");

					checkout.addModuleToStep(
						{
							step_url: 'billing'
							, module:
							{
								id: 'CertCaptureExtCheckoutView'
								, index: parseInt(index)
								, classname: 'TavanoTeam.CSExtensions.CSCertCapture.Checkout.View'

							}
						});
				}

			}
		};
	});
